/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreNrsListAliases {
  ADD_SCORE_NRS_CUSTOM_DYNAMIC_BUTTON = 'add-score-nrs-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_NRS = 'deck-score-nrs',
  FETCH_SCORE_NRS_LIST = 'fetch-score-nrs-list',
  FILTERED_LIST_SCORE_NRS = 'filtered-list-score-nrs',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_NRS_LIST = 'layout-score-nrs-list',
  LEGENDS_SCORE_NRS = 'legends-score-nrs',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_NRS_CARD = 'scores-nrs-card',
}
export { ScoreNrsListAliases };
